import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <br />
    <h2>{`🎯 Professional Experience`}</h2>
    <br />
    <br />
    <h4>{`🌕 Applied Research Works - COZEVA (Current)`}</h4>
    <p>{`SDE - 1 working with Javascript, Drupal, PHP, Twig templates`}</p>
    <br />
    <h2>{`🎯 Education`}</h2>
    <br />
    <br />
    <h4>{`🌕 KALYANI GOVERNMENT ENGINEERING COLLEGE (2018-2022)`}</h4>
    <p>{`Undergraduate Studies in Computer Science And Engineering`}</p>
    <p>{`🏆 CGPA - 9.47/10`}</p>
    <br />
    <h4>{`🌗 MDB DAV PUBLIC SCHOOL (HIGHER SECONDARY)`}</h4>
    <p>{`PCM CBSE AISSCE (2016-2018)`}</p>
    <p>{`🏆 Percentage - 96.2%`}</p>
    <br />
    <h4>{`🌑 MDB DAV PUBLIC SCHOOL (SECONDARY)`}</h4>
    <p>{`CBSE AISSE (2016)`}</p>
    <p>{`🏆 CGPA - 10/10`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      